
export const ROOT_SITE_TITLE = "Greenline Pet";

export const getPageName = (pageTitle, isAdmin) => {
    const adminText = isAdmin ? "Admin -" : "-";
    return `${ROOT_SITE_TITLE} ${adminText} ${pageTitle}`;
}
